export default "__VITE_ASSET__41c91b90__"